import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { CcoHttpUrlGenerator } from '@app/store/cco-http-url-generator';
import { TenantCampaignRegistration } from '@cco/mailer';
import { CcoDefaultDataService } from '@app/data/cco-default-data-service';

@Injectable({
  providedIn: 'any',
})
export class RegisteredEmailCampaignService extends CcoDefaultDataService<TenantCampaignRegistration> {
  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);
    const http = inject(HttpClient);
    const httpUrlGenerator = inject(CcoHttpUrlGenerator);

    super('RegisteredEmailCampaign', http, httpUrlGenerator, {
      root: config.mailerBaseUrl,
      entityHttpResourceUrls: {
        VerifiedEmailIdentity: {
          collectionResourceUrl: '/registered-campaigns',
          entityResourceUrl: '/registered-campaigns',
        },
      },
    });
  }
}
